import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

type Props = object;
export const LoadingContainer = styled.div<PropsWithChildren<Props>>`
  display: flex;
  flex-direction: column;
  width: 90%;
  padding: 16px;
  background-color: transparent;
`;
